import 'react';
import { breakpoints } from '@ui/css';
import { ShowFor } from '@utils/react';
import { MyTeamsTable } from './atom.table.js';
import { groupCls, limitedMessage } from './root.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function MyTeams() {
  return /*#__PURE__*/jsxs("div", {
    className: groupCls,
    children: [/*#__PURE__*/jsx(MyTeamsTable, {}), /*#__PURE__*/jsx(ShowFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsx("div", {
        className: limitedMessage,
        children: "(Opret og redig\xE9r dine hold fra computer)"
      })
    })]
  });
}

export { MyTeams };
//# sourceMappingURL=root.js.map
